import { z } from "zod";

export const QRIAttribute = z.object({
  label: z.string(),
  qri: z.string(),
});

export type QRIAttribute = z.infer<typeof QRIAttribute>;
